@if (panels().length) {
    <div class="cta-pair" [class.cta-pair--single]="panels().length === 1" data-cy="cta-side-by-side">
        @for (panel of panels(); track $index; let i = $index) {
            <section
                class="cta-panel"
                [class.cta-panel--dark]="i % 2 === 0"
                [class.sir-text-context-on-dark]="i % 2 === 0"
                [class.cta-panel--light]="i % 2 === 1"
                [attr.aria-labelledby]="headingId(i)"
                data-cy="panel">
                <div class="cta-panel__inner">
                    <h2 class="cta-panel__title" [id]="headingId(i)" data-cy="title">{{ panel.title }}</h2>
                    @if (panel.textHtml; as text) {
                        <div class="cta-panel__text" [innerHTML]="text" data-cy="text"></div>
                    }
                    <div class="cta-panel__actions">
                        @for (button of panel.buttons; track $index; let first = $first) {
                            <a
                                siriusButton
                                [class.cta-panel__button--primary]="first && i % 2 === 0"
                                [buttonType]="first ? 'primary' : 'secondary'"
                                [buttonText]="button.link.title"
                                [siriusLink]="button.link"
                                size="large"
                                data-cy="button">
                            </a>
                        }
                    </div>
                </div>
            </section>
        }
    </div>
}
